<template>

  <div class="ghindex-main">
    <template v-if="sliderInfo && sliderInfo != 'error'">

        <div class="banner">
            <swiper :options="swiperOption">
                <swiper-slide v-for="slider in sliderInfo" class="swiper-no-swiping">
                    <a :href="slider.url" target="_blank" :data-id="slider.ad_id">
                      <img :src="slider.content" alt="slider.ad_name">
                    </a>
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination_1"  slot="pagination"></div>
                <div class="swiper-button-prev swiper-button-prev_1" slot="button-prev"></div>
                <div class="swiper-button-next swiper-button-next_1" slot="button-next"></div>
            </swiper>
        </div>
        <div class="service-upgrade-tips" :class="{'hide':upgradeStatus}" @click="upgrade">一些神奇功能待解锁，立即升级服务！</div>
        <care></care>
        <h2 class="title pb0">关怀提醒<!-- <a :href="getUrls.memberCare" class="more">查看更多</a> --></h2>


        <div class="boxlist little">
            <template v-if="remindInfo == 0">
                <div class="box-null">
                    <p>最近没有关怀需提醒哦</p>
                </div>
            </template>
            <template v-else-if="remindInfo.length">
                <swiper :options="remindInfoSwiperOption">
                    <swiper-slide v-for="md in remindInfo.data" class="swiper-no-swiping" >
                        <a :href="goCare(md.right,md.cat_id,md.type,md.id,md.org_root_id)" @click.stop="isRight(md.right,$event)" class="box" :target="setTarget(md.right,md.type)">
                            <div class="top">
                                <img :src="md.pic" :alt="md.name">
                            </div>
                            <div class="bot">
                                <h3>{{md.name}}</h3>
                                <template v-if="md.type == 2">
                                    <p>{{md.brief}}</p>
                                    <span>倒计时{{md.diff}}天</span>
                                </template>
                                <template v-else>
                                    <p>{{md.total}}人要过{{md.cat_name}}啦</p>
                                    <span>{{md.tobe}}人未做关怀</span>
                                </template>
                            </div>
                        </a>
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </template>
            <template v-else>
                <template v-for="md in remindInfo">
                    <a :href="goCare(md.right,md.cat_id,md.type,md.id,md.org_root_id)" class="box mtb15" :target="setTarget(md.right,md.type)">
                          <div class="top">
                              <img :src="md.pic" :alt="md.name">
                          </div>
                          <div class="bot">
                              <h3>{{md.name}}</h3>
                              <template v-if="md.type == 2">
                                  <p>{{md.brief}}</p>
                                  <span>倒计时{{md.diff}}天</span>
                              </template>
                              <template v-else>
                                  <p>{{md.total}}人要过生日啦</p>
                                  <span>{{md.tobe}}人未做关怀</span>
                              </template>
                          </div>
                      </a>
                  </template>
            </template>
        </div>

        <h2 class="title pt0">日常数据</h2>
        <div class="ghindex-chart">
          <div class="box fl">
            <h3>福利开支<small v-if="getSpending">（总开支：￥{{fixedTwoFun(getSpending.amount)}}元）</small></h3>
            <div class="charts">
                <div id="main" style="width:100%;height:310px;"></div>
            </div>
          </div>
          <div class="box fr">
            <h4 class="sub">员工关怀</h4>
            <div class="itemdev">
                <template v-if="getInfomation">
                    <template v-if="getInfomation.right == 1">
                        <a :href="getUrls.carePlan" class="item fl">
                            <i class="chart1"></i>
                            <p>进行中的关怀计划<br><span>{{getInfomation.underway}}个</span></p>
                        </a>
                    </template>
                    <template v-else>
                        <div class="item fl noPower">
                            <i class="chart1"></i>
                            <p>进行中的关怀计划<br><span>{{getInfomation.underway}}个</span></p>
                        </div>
                    </template>
                </template>
                <div class="item fr noPower">
                    <i class="chart2"></i>
                    <p>从未收过关怀的员工<br><span style="color: #333333;cursor: default" v-if="getInfomation">{{getInfomation.uncare}}人</span></p>
                </div>
            </div>
            <div class="line"></div>
            <h4 class="sub">福利领取</h4>
            <div class="itemdev">
                <template v-if="getInfomation">
                    <template v-if="getInfomation.right == 1">
                        <a :href="getUrls.carePlan" class="item fl">
                            <i class="chart3"></i>
                            <p>待领取福利<br><span>{{getInfomation.waiting}}个</span></p>
                        </a>
                        <a :href="getUrls.carePlan" class="item fr">
                            <i class="chart4"></i>
                            <p>过期未领取福利<br><span>{{getInfomation.overdue}}人</span></p>
                        </a>
                    </template>
                    <template v-else>
                        <div class="item fl noPower">
                            <i class="chart3"></i>
                            <p>待领取福利<br><span>{{getInfomation.waiting}}个</span></p>
                        </div>
                        <div class="item fr noPower">
                            <i class="chart4"></i>
                            <p>过期未领取福利<br><span>{{getInfomation.overdue}}人</span></p>
                        </div>


                    </template>
                </template>
            </div>
          </div>
        </div>
        <template v-if="getActivity&&getActivity.length>0">
            <h2 class="title">活动中心</h2>
            <div class="boxlist">
                <template v-for="ac in getActivity">
                    <a :href="ac.link" class="box" target="_blank">
                        <div class="top" :data-aid="ac.id">
                            <span class="smart">{{ac.type}}</span>
                            <img :src="ac.img_url" width="100%" height="100%" :alt="ac.title">
                        </div>
                        <div class="activity">
                            <span class="tag">{{ac.status}}</span>
                            <h3>{{ac.title}}</h3>
                            <p>{{ac.description}}</p>
                            <p class="time">{{ac.end_time_field}}{{ac.end_time}}<i>{{ac.page_views}}</i></p>
                        </div>
                    </a>
                </template>
            </div>
        </template>
    </template>
    <template v-else-if="sliderInfo == 'error'">
        <p>{{errorTips}}</p>
    </template>
    <Modal v-model="showRighted" width="360" name="mos">
        <div class="iveiew-modal-content">
              暂无权限，请联系系统管理员开通！
          </div>
          <div slot="footer">
              <button class="btn btn-s btn-default btn-long" type="button" @click="showRighted = false">知道了</button>
          </div>
    </Modal>
  </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import httpPost from './api/careHome'
import config from '../../config/config'
import Cookie from 'js-cookie'
// import echarts from './assets/js/echarts.simple.min'
Array.prototype.max = function() {
  var max = this[0];
  var len = this.length;
  for (var i = 1; i < len; i++){
    if (this[i] > max) {
    max = this[i];
    }
  }
  return max;
}
import {Modal}  from 'iview';
import Vue from 'vue'
import Care from './component/care.vue'
// Vue.use(Modal)
Vue.component('Modal', Modal);

export default {
  components: {
      swiper,
      swiperSlide,
      Care
  },
  data() {
      return {
          showRighted: false,//关怀提醒没有权限时弹层控件
          chart:null,
          all_amount : '',
          spending:{},
          errorTips:'数据加载错误',
          swiperOption: {
              notNextTick: true,
              autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: true,
            },
              loop: true,
              //grabCursor : true,
              setWrapperSize :true,
              pagination : '.swiper-pagination_1',
              paginationClickable :true,
                navigation: {
                    nextEl: '.swiper-button-next_1',
                    prevEl: '.swiper-button-prev_1',
                }
          },
          remindInfoSwiperOption:{
              slidesPerView:4,
              spaceBetween : 16,
              notNextTick: true,
              loop: false,
              navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
          },
          loading: true,
          bar: {
              title: {show:false},
              tooltip: {},
              xAxis: {
                  data: [],
              },
              grid:{
                  //width:'100px'
              },
              yAxis: {
                  name:'金额/元',
              },
              color:['#58d1f9'],
              series: []
          }
      }
  },
  props: {
    // "Modal": Modal
  },
  computed: {
    ...mapGetters({
        getinfo:'getInfos',
        everyDayInfo:'getEveryDay',
        done :'doneTodosCount',
        addNumber:'getAddNumber',
        saasSearchCorpInfo: 'saasSearchCorpInfo'
    }),
    total(){
        return this.done;
    },
    infos(){
        return this.getinfo;
    },
    sliderInfo(){
        if(this.getinfo.errno){
            this.errorTips = this.getinfo.error
            return 'error'
        }
        if(this.getinfo){
            return this.getinfo.slider;
        }
    },
    remindInfo(){
        if(this.getinfo.remind.length <= 0 ){
            return 0;
        }else if(this.getinfo.remind.length > 4){
            return {
                length : '>5',
                data : this.getinfo.remind
            }
        }else{
            return {
                length : '0<length<=4',
                data:this.getinfo.remind
            };
        }
    },
    getInfomation(){
        if(this.everyDayInfo){
            return this.everyDayInfo;
        }
    },
    getSpending(){
        if(this.everyDayInfo){
            let spend = this.everyDayInfo.spending;


            let xArray = [];
            let yArray = [];
            for(let x in spend){
                xArray.push(x)
                yArray.push(Number(spend[x]))
            }
            xArray = xArray.splice(1).reverse();
            yArray = yArray.splice(1).reverse();
            let _maxNum = yArray.max();
            let _danwei;
            if(_maxNum > 99999){
                _danwei = '金额/万元'
                for(let i=0;i<yArray.length;i++){
                    yArray[i] = yArray[i] / 10000;
                }
            }else{
                _danwei = '金额/元'
            }
            for(let i=0;i<xArray.length;i++){
                xArray[i] = Number(xArray[i].slice(5,7))+'月'
            }
            this.$nextTick(function() {
                  this.drawGraph('main',xArray,yArray,_danwei)
            })
            return spend;
        }
    },
    getActivity(){
        return this.getinfo.active
    },
    getUrls(){
      console.log("agh",agho)
      let prefix='/AiGuanHuai/';
      let urlObj={}
      console.log("agho.urls",agho.urls)
      if(agho.urls){
          if(agho.urls.hasOwnProperty('agh/hrAssistant')){
            urlObj.hrAssistant=agho.urls['agh/hrAssistant']
            if(urlObj.hrAssistant.split('?')[1]){
              urlObj.hrAssistantParams=true;
            }
          }else{
            urlObj.hrAssistant=prefix+'agh/hrAssistant'
          }
          if(agho.urls.hasOwnProperty('agh/pop/carePlanSetting')){
            urlObj.carePlanSetting=agho.urls['agh/pop/carePlanSetting']
            if(urlObj.carePlanSetting.split('?')[1]){
              urlObj.carePlanSettingParams=true;
            }
          }else{
            urlObj.carePlanSetting=prefix+'agh/pop/carePlanSetting'
          }
          if(agho.urls.hasOwnProperty('agh/carePlan')){
            urlObj.carePlan=agho.urls['agh/carePlan']
            if(urlObj.carePlan.split('?')[1]){
              urlObj.carePlanParams=true;
            }
          }else{
            urlObj.carePlan=prefix+'agh/carePlan'
          }
           if(agho.urls.hasOwnProperty('agh/memberCare')){
            urlObj.memberCare=agho.urls['agh/memberCare']
            if(urlObj.memberCare.split('?')[1]){
              urlObj.memberCareParams=true;
            }
          }else{
            urlObj.memberCare=prefix+'agh/memberCare'
          }
          if(agho.urls.hasOwnProperty('agh/pop/birthdayTopic')){
            urlObj.birthdayTopic=agho.urls['agh/pop/birthdayTopic']
            if(urlObj.birthdayTopic.split('?')[1]){
              urlObj.birthdayTopicParams=true;
            }
          }else{
            urlObj.birthdayTopic=prefix+'agh/pop/birthdayTopic'
          }
      }else{
        urlObj.hrAssistant=prefix+'agh/hrAssistant'
        urlObj.carePlanSetting=prefix+'agh/pop/carePlanSetting'
        urlObj.carePlan=prefix+'agh/carePlan'
        urlObj.memberCare=prefix+'agh/memberCare'
        urlObj.birthdayTopic=prefix+'agh/pop/birthdayTopic'
      }
      console.log('urlObj',urlObj)
      return urlObj;
    },
    upgradeStatus(){
        let status = false;
        if(this.saasSearchCorpInfo){
            if(this.saasSearchCorpInfo.source == 'KA' || this.saasSearchCorpInfo.info.serviceLevel != 1){
                status = true;
            }
        }
        return status;
    }
  },
  watch:{

  },
  methods:{
    ...mapActions({}),
    fixedTwoFun(val){
      let value=String(val),result;
      if(value.split('.')[1]&&value.split('.')[1].length>2){
        result=value.split('.')[0]+'.'+value.split('.')[1].substring(0,2);
      }else{
        result=value;
      }
      return result;
    },
    goCare(right,cat_id,type,id,org_id){
      let hrAssistantUrl=this.getUrls.hrAssistantParams?this.getUrls.hrAssistant+'&':this.getUrls.hrAssistant+'?';
      let carePlanSettingUrl=this.getUrls.carePlanSettingParams?this.getUrls.carePlanSetting+'&':this.getUrls.carePlanSetting+'?';
      let birthdayTopicUrl=this.getUrls.birthdayTopicParams?this.getUrls.birthdayTopic+'&':this.getUrls.birthdayTopic+'?';
        if(right == 1){
            if(type == 1){
                if(!org_id){
                    return `${hrAssistantUrl}sceneCatId=${cat_id}`
                }else{
                    return `${hrAssistantUrl}sceneCatId=${cat_id}&org_root_id=${org_id}`
                }
            }else if(type == 2){
               return `${birthdayTopicUrl}cat_id=${cat_id}&scene_id=${id}`
            }
        }else{
            return 'javascript:void(0)'
        }
    },
    isRight(right, event) {
        if(right!=1) {
            event.preventDefault();
            console.log(event);
            this.showRighted = true;
            return ;
        }
    },
    setTarget(right,type){
        if(right == 1){
            if(type == 1){
                return `_self`
            }else if(type == 2){
                return `_blank`
            }
        }else{
            return `_self`
        }
    },
    drawGraph(id,x,y,danwei) {
        let chart = echarts.init(document.getElementById(id))
        var option = {
            title: {show:false},
            tooltip: {
            },
            grid:{
                //width:'100px'
            },
            yAxis: {
                name:danwei,
            },
            color:['#58d1f9'],
            xAxis: {
                data: x
            },
            series: [{
                name: '开支',
                type: 'bar',
                data: y,
                barWidth:32,
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#59d2f9'},
                                {offset: 1, color: '#46adf0'}
                            ]
                        ),
                    },
                    emphasis: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#59d2f9'},
                                {offset: 1, color: '#46adf0'}
                            ]
                        )
                    }
                },
            }]
        };
        chart.setOption(option)
    },
    upgrade(){
    //   window.location.href = '/AiGuanHuai/agh/hrAssistant?model=serviceCenter';
      window.location.href = '/AiGuanHuai/agh/pop/error';
    },
  },
  created(){
      this.$store.dispatch('loadHomeDatas',{});
      this.$store.dispatch("saasSearchCorpInfo");
  },
  mounted(){
  }
}
</script>

<style lang="less" scoped>
.service-upgrade-tips{
    cursor: pointer;
    margin-top: 20px;
    text-align: center;
    height:40px;
    line-height: 40px;
    background:rgba(89,210,249,1) url("./assets/img/icon21.png") 320px 8px no-repeat;
    border-radius:6px;
    font-size:14px;
    font-weight:bold;
    color:rgba(255,255,255,1);
    &.hide{
        display: none;
    }
}
</style>